<template>
  <StemdoersManager />
</template>

<script setup>
import StemdoersManager from '@/sections/manager/stemdoers/StemdoersManager.vue';
</script>
